import app from 'flarum/forum/app';
export const supportsWebPush = () => 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
export const getVapidPublicKey = () => app.forum.attribute('vapidPublicKey');
export const pushConfigured = () => Boolean(getVapidPublicKey());
export const hasEnabledPushPreference = () => {
  const preferences = app.session.user?.preferences();
  if (!preferences) return false;
  return Object.entries(preferences).some(_ref => {
    let [key, enabled] = _ref;
    return key.startsWith('notify_') && key.endsWith('_push') && enabled === true;
  });
};
flarum.reg.add('fof-pwa', 'forum/push/utils', { supportsWebPush: supportsWebPush,getVapidPublicKey: getVapidPublicKey,pushConfigured: pushConfigured,hasEnabledPushPreference: hasEnabledPushPreference, });